module.exports = __webpack_public_path__ + "mobile_app_chatroc360_qr_code_ios.a20af07.png";